import React, {useEffect, useState} from "react";
import {connect} from "react-redux";

import {getLookList, getSameColorFeatures} from "../lookNavigation/lookFunctions";
import {setGroheSameColorActiveFeature, setGroheSameColorCheckboxApplied} from "../../../actions/groheFunctions";
import {checkIfLookFeaturesReceived} from "../../../api/look-api";
import store from "../../../store";
import {updateNavigationCount} from "../../../actions/lookFunctions";
import {getCurrentLayout} from "../../appLayout";
import {useIsMounted} from "../../../misc/helperHooks";

export default (WrappedComponent) => {

  const WithFeatureColorMatch = (props) => {

    const {lookActiveFeature, filterGroups, setGroheSameColorCheckboxApplied, setGroheSameColorActiveFeature,
      wizardActiveItem, updateNavigationCount, navigationCount, currentCategory} = props;

    const [sameColorFeatures, setSameColorFeatures] = useState([]);
    const [currentColorFeatures, setCurrentColorFeatures] = useState([]);

    const isMounted = useIsMounted();

    const checkMatchingFeatures = async () => {
      if (wizardActiveItem) {
        return
      }
      const layout = getCurrentLayout();
      const featureGroup = lookActiveFeature ? lookActiveFeature.getParent() : layout.getFeatureGroupByPartId(currentCategory);
      if (featureGroup && !featureGroup.allFeaturesReceived) {
        return
      }
      const featureGroups = getLookList(true);
      if (featureGroups) {
        let promises = [];
        for (let parentObject of featureGroups) {
          if (parentObject.featureGroup && !parentObject.featureGroup.allFeaturesReceived && !parentObject.featureGroup.requestInProgress) {
            // we have to request features on th background before the colors are applied, so we can match properly
            promises.push(checkIfLookFeaturesReceived(parentObject.featureGroup).then(() => {
              const {lookActiveCategory} = store.getState().lookState;
              if (parentObject.featureGroup.partId === lookActiveCategory) {
                store.dispatch(updateNavigationCount()) // if it was launched faster - update navigation list
              }
            }));
          }
        }
        await Promise.all(promises);
      }
      if (lookActiveFeature) {
        const {sameColorFeatures, differentColorFeatures} = getSameColorFeatures(lookActiveFeature, filterGroups);
        setGroheSameColorCheckboxApplied(false);
        if (isMounted()) {
          setSameColorFeatures(sameColorFeatures); // same color but different feature groups
          setCurrentColorFeatures(differentColorFeatures); // same color but different feature groups
        }
        setGroheSameColorActiveFeature(lookActiveFeature); // same color but different feature groups
      }
    }

    useEffect(() => {
      checkMatchingFeatures();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lookActiveFeature, wizardActiveItem, navigationCount]);

    return <WrappedComponent {...props} sameColorFeatures={sameColorFeatures} currentColorFeatures={currentColorFeatures}/>

  };

  const mapStateToProps = (store) => {
    const {lookActiveFeature, lookActiveCategory, navigationCount} = store.lookState;
    const {filterGroups} = store.filterState;
    const {wizardActiveItem} = store.wizardState;
    return {
      lookActiveFeature,
      currentCategory: lookActiveCategory,
      navigationCount,
      filterGroups,
      wizardActiveItem
    };
  };

  const mapDispatchToProps = {
    setGroheSameColorCheckboxApplied,
    setGroheSameColorActiveFeature,
    updateNavigationCount,
  };

  return connect(mapStateToProps, mapDispatchToProps)(WithFeatureColorMatch)
}


